import { StatesModule, Transition } from '@uirouter/angular';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { Ng2StateDeclaration } from '@uirouter/angular';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ForumService } from '@fi-app/forum/forum.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { ForumModel } from '@fi-app/forum/forum.model';
import { ForumEditComponent } from '@fi-app/forum/forum-edit/forum-edit.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export function ForumListPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitleByItem(ObjectTypes.Forum);
}

export function ForumAddPageTitle(ccmPageTitle: PageTitleService, forum: ForumModel) {
    return ccmPageTitle.setTitleByItem(forum);
}
export function ForumAddForum(forumService: ForumService) {
    return forumService.createInstance();
}
const ForumAddState: Ng2StateDeclaration = {
    name: FiStateNames.Forum.Add,
    url: '/Add',
    views: {
        '@Module': {
            component: ForumEditComponent,
        },
    },
    resolve: {
        pageTitle: [PageTitleService, 'forum', ForumAddPageTitle],
        forum: [ForumService, ForumAddForum],
    },
};

export function ForumEditPageTitle(ccmPageTitle: PageTitleService, forum: ForumModel) {
    return ccmPageTitle.setTitleByItem(forum);
}
export function ForumEditForum(forumService: ForumService, stateService: FiStateService, transition: Transition) {
    return forumService.getForum(stateService.getParams(transition).id);
}
const ForumEditState: Ng2StateDeclaration = {
    name: FiStateNames.Forum.Edit,
    url: '/{id:[0-9]+}/Edit',
    views: {
        '@Module': {
            component: ForumEditComponent,
        },
    },
    resolve: {
        pageTitle: [PageTitleService, 'forum', ForumEditPageTitle],
        forum: [ForumService, FiStateService, Transition, ForumEditForum],
    },
};

export const ForumStates: StatesModule = {
    states: [ForumAddState, ForumEditState],
};

export function registerForumStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.Forum.Edit, FiStateNames.Forum.Add], {
        SettingType: [ApplicationSettingsType.ForumAdmin],
        AccessType: AccessRightType.Read,
    });
}
